import bus, { EVENTS } from './bus';

const tickTextstyle = {
  dropShadow: true,
  dropShadowAlpha: 0.2,
  dropShadowAngle: 1.8,
  dropShadowDistance: 2,
  padding: 5
};

export default class Crop extends PIXI.Graphics {
  constructor(crop, viewport) {
    super();

    this.crop = crop;
    this.viewport = viewport;

    this.is_selected = false;

    this.interactive = true;
    this.cursor = 'pointer';

    this.listenBusEvents();

    const { boundaries } = this.crop;

    this.rect_width = boundaries.bottom_right.x - boundaries.top_left.x;
    this.rect_height = boundaries.bottom_right.y - boundaries.top_left.y;

    this.rect_y = parseFloat(boundaries.top_left.y);
    this.rect_x = parseFloat(boundaries.top_left.x);
    this.renderRect();
  }

  getLineWidth = () => {
    const baseWidth = this.is_selected ? 12 : 3;
    const lineWidth = baseWidth / bus.viewport.scale.x;

    return lineWidth < 0.5 ? 0.5 : lineWidth;
  }

  renderRect() {
    let lineColor = 0x409eff;
    const unrecognized_color = 0x57e0c1;
    const meta_color = 0xecd930;
    const non_sku_color = 0xff6600;

    this.is_validated = !!bus.ValidatedCrops.data.body.find(crop => crop.boundaries.top_left.x === this.crop.boundaries.top_left.x
      && crop.boundaries.top_left.y === this.crop.boundaries.top_left.y
      && crop.boundaries.bottom_right.x === this.crop.boundaries.bottom_right.x
      && crop.boundaries.bottom_right.y === this.crop.boundaries.bottom_right.y);

    if (this.crop.is_unrecognized) {
      lineColor = unrecognized_color;
    }

    if (this.crop.is_meta) {
      lineColor = meta_color;
    }

    if (this.crop.is_nonSku) {
      lineColor = non_sku_color;
    }

    const {
      rect_x: x,
      rect_y: y,
      rect_width: width,
      rect_height: height
    } = this;

    this.clear();
    this.removeChildren();
    this.beginFill(0xffffff, 0.1);
    this.lineStyle(this.getLineWidth(), lineColor, 1, 0);
    this.drawRoundedRect(x, y, width, height, 2);
    this.endFill();

    if (this.is_validated) {
      const scaled_size = this.width / 4;

      const ellipse_size = scaled_size > 120 ? 120 : scaled_size;
      const sprite = new PIXI.Text('✔', new PIXI.TextStyle({ ...tickTextstyle, fill: lineColor, fontSize: ellipse_size }));

      const center_x = (x + width / 2);
      const center_y = (y + height / 2);

      this.lineStyle(6, lineColor, 1, 0);
      this.beginFill(0xffffff, 1);
      this.drawEllipse(center_x, center_y, ellipse_size, ellipse_size);
      this.endFill();

      sprite.x = center_x - sprite.width / 2;
      sprite.y = center_y - sprite.height / 2;

      this.addChildAt(sprite, 0);
    }
  }

  mouseover() {
    this.showToolTip();
  }

  touchstart() {
    this.showToolTip();
  }

  touchend() {
    this.destroyToolTip();
  }

  mouseout() {
    this.destroyToolTip();
  }

  getCropWithBounds() {
    return {
      bounds: this.getBounds(),
      crop: this.crop
    };
  }

  destroyToolTip = () => {
    if (!bus.selected_crop) {
      bus.$emit(EVENTS.DESTROY_TOOLTIP);
    }
  }

  click() {
    bus.$emit(EVENTS.RENDER_SELECTED_CROP, this.crop);

    bus.selectCrop(this.getCropWithBounds());

    this.renderRect();
  }

  showToolTip() {
    if (!bus.selected_crop) {
      bus.$emit(EVENTS.SHOW_TOOL_TIP, this.getCropWithBounds());
    }
  }

  listenBusEvents() {
    bus.$on(EVENTS.RENDER_SELECTED_CROP, (crop) => {
      if (crop.crop_id === this.crop.crop_id) {
        this.is_selected = !this.is_selected;
      } else {
        this.is_selected = false;
      }

      this.renderRect();
    });

    bus.$on(EVENTS.ZOOM_END, () => this.renderRect());
    bus.$on(EVENTS.RE_RENDER_CROP, () => this.renderRect());
  }
}
